import { Fragment } from 'react';
import { Box, Heading, Image, Text, Flex, Link, List, ListItem } from '@chakra-ui/react';
import { _js } from '@ifixit/localize';

type CertificationsType = {
   imageSrc: string;
   approvedDate: string;
   submittedDate: string;
   name: string;
   detailsLink: string;
   filename: string;
   status: string;
};

export function Certifications({
   pendingCerts = [],
   acceptedCerts = [],
}: {
   pendingCerts: CertificationsType[];
   acceptedCerts: CertificationsType[];
}) {
   return (
      <Box display={{ base: 'none', lg: 'unset' }}>
         {pendingCerts.length > 0 && <PendingCerts certs={pendingCerts} />}
         {acceptedCerts.length > 0 && <AcceptedCerts certs={acceptedCerts} />}
      </Box>
   );
}

const PendingCerts = ({ certs }: { certs: CertificationsType[] }) => (
   <Fragment>
      <Heading as="h3" color="black" fontSize="xl">
         {_js('Pending Certifications')}
      </Heading>
      <CertList certs={certs} />
   </Fragment>
);

const AcceptedCerts = ({ certs }: { certs: CertificationsType[] }) => (
   <Fragment>
      <Heading as="h3" color="black" fontSize="xl">
         {_js('Accepted Certifications')}
      </Heading>
      <CertList certs={certs} />
   </Fragment>
);

const CertList = ({ certs }: { certs: CertificationsType[] }) => (
   <List p={0}>
      {certs.map((cert: CertificationsType) => (
         <CertItem key={cert.imageSrc} cert={cert} />
      ))}
   </List>
);

const CertItem = ({ cert }: { cert: CertificationsType }) => {
   /* Translators: followed by a date */
   const approvedText = _js('Approved:');
   const approvedDate = (
      <div style={{ padding: '4px' }} dangerouslySetInnerHTML={{ __html: cert.approvedDate }} />
   );
   /* Translators: followed by a date */
   const submittedText = _js('Submitted:');
   const submittedDate = (
      <div style={{ padding: '4px' }} dangerouslySetInnerHTML={{ __html: cert.submittedDate }} />
   );
   return (
      <ListItem py={2}>
         <Flex>
            <Image boxSize={9} src={cert.imageSrc} />
            <Flex direction="column" pl={2}>
               <Text fontSize="xl" fontWeight="bold" my={0}>
                  {cert.name}
               </Text>
               {cert.approvedDate ? (
                  <Fragment>
                     <Link my={1} href={cert.detailsLink}>
                        {cert.filename}
                     </Link>
                     <Flex style={{ flexDirection: 'row', alignItems: 'center' }}>
                        <Text my={1}>{approvedText}</Text>
                        {approvedDate}
                     </Flex>
                     <Flex style={{ flexDirection: 'row', alignItems: 'center' }}>
                        <Text my={1}>{submittedText}</Text>
                        {submittedDate}
                     </Flex>
                  </Fragment>
               ) : (
                  <Text fontSize="md" m="2px 0 0">
                     {cert.status}
                  </Text>
               )}
            </Flex>
         </Flex>
      </ListItem>
   );
};
